import { IntlShape } from "react-intl";

import SavedAddressType from "@mapmycustomers/shared/enum/SavedAddressType";
import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";

import getSavedAddressTypeDisplayName from "@app/util/ui/getSavedAddressTypeDisplayName";

const getSavedAddressDisplayName = (intl: IntlShape, { name, type }: SavedAddress) =>
  type === SavedAddressType.CUSTOM ? (name ?? "") : getSavedAddressTypeDisplayName(intl, type);

export default getSavedAddressDisplayName;
